var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEdit48Line = function SvgIconEdit48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.647 12.691-1.34-1.34a5.31 5.31 0 0 0-7.5 0l-2.91 2.91-13.34 13.35a1.62 1.62 0 0 0-.47.87l-1.23 6.26a2.89 2.89 0 0 0 2.84 3.46c.188 0 .376-.02.56-.06l6.26-1.23c.33-.066.633-.23.87-.47l13.34-13.34 2.91-2.91a5.31 5.31 0 0 0 .01-7.5Zm-18.29 21-5 1 1-5 11.77-11.77 2 2 2 2-11.77 11.77Zm15.89-15.89-1.72 1.73-2-2-2-2 1.71-1.71a2 2 0 0 1 2.69 0l1.35 1.35a1.91 1.91 0 0 1 0 2.68l-.03-.05Z",
    fill: "current"
  })));
};
export default SvgIconEdit48Line;